import React, { useState, useEffect, useContext} from "react"

import {
  Box,
  Container,
  Button,
  Hidden,
} from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/fr'

import MyModal from "../ui/MyModal"
import CertifChart from "./CertifChart"
import CloseIcon from '@material-ui/icons/Close';


const ViewResultsModal = ({ isOpen, user, actScan, onClose, type}) => {

  const getLabelsForChart = () => {
    let labels = []
    let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family)); //on trie par famille (par nom de famille croissant)
    softSkillsByFamily?.forEach((skill) => {
      labels.push(skill?.key)
    })

    return labels
  }

  const getDatasForChart = () => {

    let datasets = []
    let labelsCategories = ['communication','efficacite','leadership']
    let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family)); //on trie par famille (par nom de famille croissant)

    let findResult
    let resultFin = null
    if (type === "recruiter") {
      findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      try {
        resultFin = JSON.parse(findResult?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    } else if (type === "candidat") {
      try {
        resultFin = JSON.parse(user?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    }


    let finalResult = []
    softSkillsByFamily?.forEach((skill) => {
      if (resultFin[skill.key]) {
        skill.score = resultFin[skill.key]?.score
      } else {
        skill.score = 0
      }
    })

    let dashStyle = undefined
    labelsCategories?.forEach((cat) => {
      let arr = []
      softSkillsByFamily?.forEach((skill) => {
        if (skill.family === cat) {
          if (resultFin[skill.key]) {
            arr.push(resultFin[skill.key]?.score)
          } else {
            arr.push(0)
          }
        } else {
          arr.push(0)
        }
      })


      let bgColor = ""
      let borderColor = ""
      if (cat === labelsCategories[0]) {
        bgColor = "rgba(255, 81, 6, 0.2)"
        borderColor = "rgba(255, 81, 6, 1)"
      } else if (cat === labelsCategories[1]) {
        bgColor = "rgba(79, 57, 255, 0.2)"
        borderColor = "rgba(79, 57, 255, 1)"
      } else if (cat === labelsCategories[2]) {
        bgColor = "rgba(243, 144, 255, 0.2)"
        borderColor = "rgba(243, 144, 255, 1)"
      }

      datasets.push({
        title : 0,
        data : arr,
        fill : true,
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        //spanGaps : true,
      })
    })

    let arr = []
    let color = []
    let arrFamily = []
    softSkillsByFamily?.forEach((label) => {
      arr.push(100)
      if (label.family === labelsCategories[0]) {
        arrFamily.push(labelsCategories[0])
        color.push("rgba(255, 81, 6, 1)")
      } else if (label.family === labelsCategories[1]) {
        arrFamily.push(labelsCategories[1])
        color.push("rgba(79, 57, 255, 1)")
      } else if (label.family === labelsCategories[2]) {
        arrFamily.push(labelsCategories[2])
        color.push("rgba(243, 144, 255, 1)")
      }
    });

    datasets.push({
      title : "POINTS",
      data : arr,
      fill : true,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      borderWidth : 0,
      pointRadius: 3,
      pointHoverRadius : 3,
      pointBackgroundColor: color,
      pointHoverBackgroundColor: color,
      pointBorderColor: "#B5BFCD",
      pointHoverBorderColor: "#B5BFCD",
      pointBorderWidth:1,
      pointHoverBorderWidth:1,
      //spanGaps : true,
    })

    return {
      datasets : datasets,
      arrFamily : arrFamily,
      allSkillsWithScores : softSkillsByFamily,
    }
    //console.log(data)
  }

  const getCompletedOn = () => {
    if (type === "recruiter") {
      let findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      return `Terminé ${moment(findResult?.resultUpdatedAt).calendar()}`
    } else if (type === "candidat") {
      return `Terminé ${moment(user?.resultUpdatedAt).calendar()}`
    }
  }

  const getUserName = () => {
    if (type === "recruiter") {
      return user?.userName
    } else if (type === "candidat") {
      return user?.name
    }
  }


  return (
    <>
      {isOpen &&
        <MyModal
          isOpen={isOpen}
          maxWidth="md"
          onClose={onClose}
          overflow="hidden"
          background="white"
        >
          <Box sx={{display:"flex", width:"100%", height:"100%", alignItems:"center", flexDirection:"column", overflow:"hidden"}}>
            <Box sx={{
              display:"flex",
              flexDirection:"column",
              padding:"15px",
              width:"100%",
              overflow:"hidden",
              userSelect:"none",
            }}>
              <Box sx={{
                textAlign:"right"
              }}>
                <CloseIcon onClick={onClose} sx={{
                  cursor:"pointer",
                  color:"text.black",
                  width:["25px", "35px", "35px"],
                  height:["25px", "35px", "35px"],
                  marginBottom:["-10px", "-15px", "-15px"],
                }}/>
              </Box>
              <Box sx={{
                fontWeight:500,
                color:"text.black",
                fontSize:["28px", "36px", "42px"],
                overflow:"hidden",
                whiteSpace:"nowrap",
                textOverflow:"ellipsis",
                textAlign:"center"
              }}>
                {getUserName()}
              </Box>
            </Box>
            <Box sx={{
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "16px", "18px"],
              textTransform:"capitalize",
              overflow:"hidden",
              whiteSpace:"nowrap",
              textOverflow:"ellipsis",
              maxWidth:"calc(100% - 20px)"
            }}>
              {getCompletedOn()}
            </Box>
            <Box sx={{flex:1, width:"100%", display:"flex", alignItems:"center"}}>
              <Box sx={{width:"100%"}}>
                <Hidden smDown>
                  <CertifChart
                    dataLoaded={true}
                    getLabelsForChart={getLabelsForChart}
                    getDatasForChart={getDatasForChart}
                    type={type}
                    noMarginTop
                    noPadding
                    withMaxHeight
                  />
                </Hidden>
                <Hidden smUp>
                  <CertifChart
                    dataLoaded={true}
                    getLabelsForChart={getLabelsForChart}
                    getDatasForChart={getDatasForChart}
                    type={type}
                    noPadding
                  />
                </Hidden>
              </Box>
            </Box>
          </Box>
        </MyModal>
      }
    </>
  )
};

export default ViewResultsModal;
